import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema, RunIdSchema } from "../primitives/ids.js";
import { BusinessGraphV1Schema } from "./business-graph.js";
import { PackPinSchema } from "./generation-run.js";
/** render-input.v1.0 — Surface Engine input (shared-contracts only) */
export const RenderInputV1Schema = z
    .object({
    schemaVersion: z.literal("render-input.v1.0"),
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    runId: RunIdSchema,
    recipeId: z.string().min(1),
    businessGraph: BusinessGraphV1Schema,
    packPin: PackPinSchema,
})
    .strict();
//# sourceMappingURL=render-input.js.map